<div class="mb-6 flex items-center justify-between">
  <h1 class="textTabsColor text-2xl font-bold" i18n="@@breadcrumbOrders">Orders</h1>
</div>

<app-order-filters
  [filters]="filters()"
  (toggleSortOrder)="toggleSortOrder()"
  (resetFilters)="resetFilters()"
  (applyFilters)="applyFilters($event)"
  (selectPharmacyOwner)="selectPharmacyOwner($event)" />

<app-order-table
  [orders]="orders()"
  [state]="state()"
  [currentPage]="currentPage()"
  [totalItems]="totalItems()"
  [itemsPerPage]="itemsPerPage()"
  [totalPages]="totalPages"
  [isFiltersApplied]="isFiltersApplied()"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
  (rowClick)="navigateToDetails($event)"
  (getOrders)="loadOrders()"
  (orderPrinted)="onOrderPrinted($event)"
  (openUndeliver)="onOpenUndeliver($event)"
  (actionClick)="onOrderAction($event)" />

@if (isUndeliverPopup()) {
  <app-undeliver-popup
    [orderId]="selectedUndeliverOrderId()"
    [isArabic]="isArabic()"
    [isOpen]="isUndeliverPopup()"
    (close)="onCloseUndeliver()"
    (success)="loadOrders()" />
}

@if (activeAction(); as current) {
  @switch (current.action) {
    @case ("confirm-review") {
      <app-order-action-popup
        #popup
        [loading]="submitting()"
        [err]="actionError()"
        (submit)="onConfirmReview(popup.comment())"
        [title]="isArabic() ? 'قبول مراجعة الطلب' : 'Reviewal Approve'"
        (closePopup)="closeAction()"
        [description]="
          isArabic()
            ? 'هل أنت متأكد من تأكيد مراجعة هذا الطلب؟'
            : 'Are you sure you want to confirm the review for this order?'
        "
        [submitBtnContent]="isArabic() ? 'تأكيد' : 'Confirm'" />
    }

    @case ("reject-review") {
      <app-order-action-popup
        type="detailed"
        [loading]="submitting()"
        [err]="actionError()"
        [optionData]="rejectionReasons()"
        [label]="isArabic() ? 'تعليق' : 'Comment'"
        (submit)="onRejectReview($event)"
        [title]="isArabic() ? 'رفض مراجعة الطلب' : 'Reviewal Reject'"
        (closePopup)="closeAction()"
        [description]="isArabic() ? 'لماذا تريد رفض مراجعة الطلب' : 'Why are you rejecting this order'"
        [submitBtnContent]="isArabic() ? 'رفض ' : 'Reject'"
        [detailedLabel]="isArabic() ? 'سبب الرفض' : 'Rejection Reason'"
        [optionOne]="isArabic() ? 'حدد السبب لرفض هذا الطلب' : 'select the reason for rejecting this order'" />
    }

    @case ("ship") {
      <app-order-action-popup
        #popup
        [loading]="submitting()"
        [err]="actionError()"
        [label]="isArabic() ? 'تعليق' : 'Comment'"
        (submit)="onShip(popup.comment())"
        [title]="isArabic() ? 'شحن الطلب' : 'Ship Order'"
        (closePopup)="closeAction()"
        [description]="isArabic() ? 'هل أنت متأكد من شحن الطلب ؟' : 'Are you sure you want to ship this order ?'"
        [submitBtnContent]="isArabic() ? 'شحن ' : 'Ship'" />
    }

    @case ("repackage") {
      <app-order-action-popup
        #popup
        [loading]="submitting()"
        [err]="actionError()"
        [title]="isArabic() ? 'إعادة تعبئة الطلب' : 'Repackage'"
        (closePopup)="closeAction()"
        [description]="
          isArabic()
            ? 'هل أنت متأكد من إعادة تعبئة هذا الطلب وإرساله للمراجعة مرة أخرى؟'
            : 'Are you sure you want to repackage this order and send it back for review?'
        "
        [submitBtnContent]="isArabic() ? 'تأكيد ' : 'Confirm'"
        (submit)="onRepackage(popup.comment())" />
    }

    @case ("receive-returned") {
      <app-order-action-popup
        #popup
        [loading]="submitting()"
        [label]="isArabic() ? 'تعليق' : 'Comment'"
        (submit)="onReceiveReturned(popup.comment())"
        [title]="isArabic() ? 'استلام المنتجات المرتجعة' : 'Receive Returned Products'"
        (closePopup)="closeAction()"
        [err]="actionError()"
        [description]="
          isArabic()
            ? 'هل أنت متأكد من استلام المنتجات المرتجعة ؟'
            : 'Are you sure you want to receive returned products for this order ?'
        "
        [submitBtnContent]="isArabic() ? 'تأكيد' : 'Confirm'" />
    }

    @case ("collect-cash") {
      <app-collect-cash-popup
        [expectedAmount]="collectCashExpectedAmount()"
        [loading]="submitting()"
        [err]="actionError()"
        (submit)="onCollectCash($event)"
        (closePopup)="closeAction()" />
    }

    @case ("cancel") {
      <app-order-action-popup
        type="detailed"
        [loading]="submitting()"
        [optionData]="cancellationReasons()"
        [otherReasonId]="otherCancellationReasonId()"
        (submit)="onCancelOrder($event)"
        [title]="isArabic() ? 'إلغاء الطلب' : 'Cancel Order'"
        [showOtherReason]="true"
        (closePopup)="closeAction()"
        [err]="actionError()"
        [description]="isArabic() ? 'هل أنت متأكد من إلغاء هذا الطلب؟' : 'Are you sure you want to cancel this order?'"
        [submitBtnContent]="isArabic() ? 'تأكيد الإلغاء' : 'Confirm Cancellation'"
        [detailedLabel]="isArabic() ? 'سبب الإلغاء' : 'Cancellation Reason'"
        [optionOne]="isArabic() ? 'اختر سبباً للإلغاء' : 'Select a cancellation reason'"
        [label]="isArabic() ? 'ملاحظات' : 'Notes'" />
    }
  }
}
